module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "right.61dca77f.svg";